import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
const isLoading = () => {
    return (
        <div className="myloader"><CircularProgress /></div>
    )
}

export default isLoading
